const STORAGE_KEY = 'kl_cookie_consent_v1';
const DEFAULT_CONSENT = {
    necessary: true,
    preferences: false,
    analytics: false,
    marketing: false,
    updatedAt: null,
};

function readConsent() {
    try {
        const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
        return stored ? { ...DEFAULT_CONSENT, ...stored, necessary: true } : null;
    } catch {
        return null;
    }
}

function writeConsent(consent) {
    const payload = { ...DEFAULT_CONSENT, ...consent, necessary: true, updatedAt: new Date().toISOString() };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    window.dispatchEvent(new CustomEvent('kl:cookies-updated', { detail: payload }));
    return payload;
}

function createBanner() {
    const banner = document.createElement('section');
    banner.className = 'cookie-banner';
    banner.setAttribute('aria-label', 'Preferences cookies');
    banner.innerHTML = `
        <div>
            <strong>Gestion des cookies</strong>
            <p>Nous utilisons les cookies necessaires au fonctionnement du site. Vous pouvez accepter, refuser ou personnaliser les cookies optionnels.</p>
        </div>
        <div class="cookie-banner__actions">
            <button class="btn btn-secondary" type="button" data-cookie-reject>Refuser</button>
            <button class="btn btn-secondary" type="button" data-cookie-customize>Personnaliser</button>
            <button class="btn btn-primary" type="button" data-cookie-accept>Accepter</button>
        </div>
    `;
    document.body.appendChild(banner);
    return banner;
}

function createPanel() {
    const panel = document.createElement('div');
    panel.className = 'cookie-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', 'Personnaliser les cookies');
    panel.innerHTML = `
        <div class="cookie-panel__box">
            <div class="cookie-panel__header">
                <strong>Personnaliser les cookies</strong>
                <button type="button" aria-label="Fermer" data-cookie-close>&times;</button>
            </div>
            <p>Choisissez les informations que le site peut utiliser. Les cookies necessaires ne peuvent pas etre desactives car ils servent a la session, la securite et au panier.</p>
            <label class="cookie-toggle is-disabled"><input type="checkbox" checked disabled><span>Necessaires</span><small>Session, securite, panier, consentement.</small></label>
            <label class="cookie-toggle"><input type="checkbox" name="preferences"><span>Preferences</span><small>Memorisation de certains choix d'affichage ou de confort.</small></label>
            <label class="cookie-toggle"><input type="checkbox" name="analytics"><span>Mesure d'audience</span><small>Statistiques anonymisees pour comprendre l'utilisation du site.</small></label>
            <label class="cookie-toggle"><input type="checkbox" name="marketing"><span>Marketing</span><small>Mesure des campagnes et contenus personnalises si ces outils sont ajoutes.</small></label>
            <div class="cookie-panel__actions">
                <button class="btn btn-secondary" type="button" data-cookie-reject>Tout refuser</button>
                <button class="btn btn-primary" type="button" data-cookie-save>Enregistrer mes choix</button>
            </div>
        </div>
    `;
    document.body.appendChild(panel);
    return panel;
}

function syncInputs(scope, consent) {
    scope.querySelectorAll('input[name]').forEach((input) => {
        input.checked = Boolean(consent?.[input.name]);
    });
}

function collectInputs(scope) {
    const consent = { necessary: true };
    scope.querySelectorAll('input[name]').forEach((input) => {
        consent[input.name] = input.checked;
    });
    return consent;
}

function applyPageForm(consent) {
    const form = document.querySelector('[data-cookie-form]');
    if (!form) return;
    syncInputs(form, consent || DEFAULT_CONSENT);
    const status = form.querySelector('[data-cookie-status]');
    if (status) {
        status.textContent = consent?.updatedAt
            ? `Derniere mise a jour : ${new Date(consent.updatedAt).toLocaleString('fr-FR')}`
            : 'Aucun choix enregistre pour le moment.';
    }
}

function showFeedback() {
    const pageFeedback = document.querySelector('[data-cookie-feedback]');
    if (pageFeedback) {
        pageFeedback.hidden = false;
        window.setTimeout(() => { pageFeedback.hidden = true; }, 4200);
    }

    const toast = document.createElement('div');
    toast.className = 'cookie-toast';
    toast.setAttribute('role', 'status');
    toast.textContent = 'Preferences cookies enregistrees.';
    document.body.appendChild(toast);
    window.setTimeout(() => toast.classList.add('is-visible'), 20);
    window.setTimeout(() => {
        toast.classList.remove('is-visible');
        window.setTimeout(() => toast.remove(), 220);
    }, 3200);
}

document.addEventListener('DOMContentLoaded', () => {
    let consent = readConsent();
    applyPageForm(consent);

    const openPanel = () => {
        const panel = document.querySelector('.cookie-panel') || createPanel();
        syncInputs(panel, consent || DEFAULT_CONSENT);
        panel.classList.add('is-open');
        panel.querySelector('input[name="preferences"]')?.focus();
    };
    const closePanel = () => document.querySelector('.cookie-panel')?.classList.remove('is-open');
    const closeBanner = () => document.querySelector('.cookie-banner')?.remove();
    const save = (value) => {
        consent = writeConsent(value);
        applyPageForm(consent);
        showFeedback();
        closePanel();
        closeBanner();
    };

    if (!consent) createBanner();

    document.addEventListener('click', (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;
        if (target.closest('[data-cookie-accept]')) save({ preferences: true, analytics: true, marketing: true });
        if (target.closest('[data-cookie-reject]')) save({ preferences: false, analytics: false, marketing: false });
        if (target.closest('[data-cookie-customize], [data-cookie-open]')) openPanel();
        if (target.closest('[data-cookie-close]')) closePanel();
        if (target.closest('[data-cookie-save]')) {
            const scope = target.closest('.cookie-panel') || document;
            save(collectInputs(scope));
        }
    });

    document.addEventListener('submit', (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || !form.matches('[data-cookie-form]')) return;
        event.preventDefault();
        save(collectInputs(form));
    });
});
